export function fileLoader(obj: any) {
  // https://github.com/facebook/create-react-app/issues/9721
  return typeof obj.default === 'string' ? obj.default : obj;
}
